import { CenteredCol } from '../StyledPrimitives/StyledPrimitives';
import styled from 'styled-components';

const TimeColoredCenteredCol = styled(CenteredCol)`
    background: ${props => props.isDay ? '#33b8ff' : 'black'}
`;

export default TimeColoredCenteredCol;


// WEBPACK FOOTER //
// ./src/components/Job/TimeColoredCenteredCol.js